var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.deduplicatedList,"dense":"","hide-default-footer":"","multi-sort":"","sort-by":['display', 'formattedPlanDate'],"sort-desc":[false, true]}})
}
var staticRenderFns = []

export { render, staticRenderFns }